/** Farben und Schatten des Designs `Neue Kampagne.dc.html`. */
export const wz = {
  primary: '#4F44FF',
  primarySoft: '#EDECFF',
  selectedBg: '#F8F8FF',
  page: '#F5F5FB',
  border: '#E3E3E8',
  borderSoft: '#F5F5FB',
  dashed: '#C9CCD3',
  muted: '#707070',
  text: '#1C1C1C',
  textDim: '#373737',
  text555: '#555',
  success: '#18A31F',
  warnBg: '#fbe6c3',
  warnFg: '#8E4101',
  redBg: '#fee',
  redFg: '#940202',
  greenBg: '#daf696',
  blueBg: '#cfd6fb',
  gradient: 'linear-gradient(to right,#4F44FF,#007FFF)',
  gradientHover: 'linear-gradient(to right,#007FFF,#4F44FF)',
  shadowCard: '0 1px 3px 0 rgba(0,0,0,0.06)',
  shadowMenu: '0 4px 12px 0 rgba(0,0,0,0.18)',
} as const;
